import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
const faqs = [{
  q: '¿Es material digital?',
  a: 'Sí, accedés desde cualquier dispositivo con internet. Lo recibís en tu mail y podés descargarlo a tu computadora, tablet o celular.'
}, {
  q: '¿Cómo lo recibo?',
  a: 'Recibís el acceso por email apenas se confirma el pago. Es inmediato: si pagás de noche, lo tenés esa misma noche. Sin esperas.'
}, {
  q: '¿Puedo imprimirlo?',
  a: 'Sí, todo el material está optimizado para imprimir y llevar a tu estudio. Los archivos son PDFs de alta calidad.'
}, {
  q: '¿Sirve para cualquier estilo de yoga?',
  a: 'Sí, está pensado para Hatha, Vinyasa, Ashtanga, Terapéutico y más. Cada secuencia trae variantes para adaptarla a la realidad de tus alumnos.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'No. El sistema te guía paso a paso, desde la centración inicial hasta Savasana. Las posturas y secuencias están explicadas claramente.'
}, {
  q: '¿Puedo usarlo durante todo el año?',
  a: 'Sí, tenés material suficiente para planificar clases durante todo el año sin repetir secuencias.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 lg:py-32 bg-white" data-id="element-41">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-43">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-brand-50 text-brand-700 font-medium text-xs uppercase tracking-widest mb-6 border border-brand-100/50" data-id="element-44">
            Preguntas frecuentes
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-medium text-ink-900 mb-6 leading-tight tracking-tight" data-id="element-45">
            Resolvemos tus <span className="text-brand-600 italic" data-id="element-46">dudas</span>
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-47">
          {faqs.map((faq, index) => {
          const open = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.04
          }} className={`bg-[#FAF8F5] rounded-[2rem] border transition-all duration-300 overflow-hidden ${open ? 'border-brand-200 shadow-md' : 'border-accent-100/50 shadow-sm'}`} data-id="element-48">
                <button onClick={() => setOpenIndex(open ? null : index)} className="w-full px-8 py-6 text-left flex justify-between items-center focus:outline-none gap-6" aria-expanded={open} data-id="element-49">
                  <span className="font-medium text-ink-900 text-base lg:text-lg" data-id="element-50">
                    {faq.q}
                  </span>
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 shrink-0 ${open ? 'bg-brand-700 text-white rotate-45' : 'bg-white text-brand-600 shadow-sm'}`} data-id="element-51">
                    <Plus className="w-5 h-5" strokeWidth={1.5} data-id="element-52" />
                  </div>
                </button>
                <AnimatePresence data-id="element-53">
                  {open && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-54">
                      <div className="px-8 pb-8 text-ink-600 leading-relaxed font-light" data-id="element-55">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}